import React from "react";

const humanizeLabel = (label) => {
  if (!label) return label;
  return label
    .toString()
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase());
};

// Renders a DemographicCount[] ({ label, count, percentage }) as labeled progress bars.
const DemographicList = ({ title, icon, items, emptyLabel, translateLabel }) => (
  <div className="mb-3">
    <h6 className="fw-bold mb-2 small text-uppercase text-muted">
      {icon && <i className={`fas ${icon} me-2`}></i>}
      {title}
    </h6>
    {!items || items.length === 0 ? (
      <p className="text-muted small mb-0">{emptyLabel}</p>
    ) : (
      items.map((item) => (
        <div key={item.label} className="mb-2">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small fw-medium">
              {translateLabel ? translateLabel(item.label) : humanizeLabel(item.label)}
            </span>
            <span className="small text-muted">
              {item.count} ({parseFloat(item.percentage || 0).toFixed(1)}%)
            </span>
          </div>
          <div className="progress" style={{ height: "6px" }}>
            <div
              className="progress-bar bg-primary"
              style={{ width: `${item.percentage || 0}%` }}
            ></div>
          </div>
        </div>
      ))
    )}
  </div>
);

export default DemographicList;
